    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                         @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">

                                                
                                                            <el-form-item label="创建时间:" >
                                    <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                                                    end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                                    </el-date-picker>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="会员卡名称:">
                                    <el-input v-model="table.where.name" placeholder="请输入会员卡名称"  clearable/>
                                </el-form-item>
                                                                                                        
                                                                                                        
                                                            <el-form-item label="会员价格:">
                                    <el-input-number v-model="table.where.price" controls-position="right" :min="0" :controls="false"
                                                     :precision="2" class="ele-fluid ele-text-left" placeholder="请输入会员价格" clearable />
                                </el-form-item>

                                                                                                        
                                                            <el-form-item label="会员天数:">
                                    <el-input-number v-model="table.where.day" placeholder="请输入会员天数" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="卡状态，2显示，3隐藏:">
                                    <el-input-number v-model="table.where.status" placeholder="请输入卡状态，2显示，3隐藏" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                                </el-form-item>
                                                                                                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                       class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                                       v-if="permission.includes('sys:membercard:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                               class="ele-btn-icon" size="small" >刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:membercard:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:membercard:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                               @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left"/>
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
                                                                                                                                        
                                    <el-table-column prop="name" label="会员卡名称" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    <el-table-column prop="img" label="图片标识" show-overflow-tooltip min-width="250" >
                                    <template slot-scope="{row}">
                                        <el-image
                                                style="width: 50px; height: 50px"
                                                :src="row.img"
                                                :preview-src-list="[row.img]">
                                        </el-image>
                                    </template>
                                </el-table-column>
                                                                                                                
                                    <el-table-column prop="price" label="会员价格" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="day" label="会员天数" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="status" label="卡状态，2显示，3隐藏" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                        
                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:membercard:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此会员卡信息吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:membercard:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改会员卡信息':'添加会员卡信息'" :visible.sync="showEdit"  width="800px" :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                                                                        
                                                                                                                
                                                                <el-form-item label="会员卡名称:" prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入会员卡名称" clearable />
                                </el-form-item>
                                                                                                            
                                
                                <el-form-item label="图片标识:" prop="img">
                                    <ele-uploadimage :limit="1" v-model="editForm.img"></ele-uploadimage>

                                </el-form-item>
                                                                                                            
                                
                                <el-form-item label="会员价格:" prop="price">
                                    <el-input-number v-model="editForm.price" controls-position="right" :min="0" :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入会员价格" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="会员天数:" prop="day">
                                    <el-input-number v-model="editForm.day" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入会员天数" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="卡状态，2显示，3隐藏:" prop="status">
                                    <el-input-number v-model="editForm.status" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入卡状态，2显示，3隐藏" clearable />
                                </el-form-item>
                                                                                                    
                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import { mapGetters } from "vuex";

                import EleUploadimage from '@/components/EleUploadimage'
                                        
        export default {
            name: "SysMemberCard",
            components: {
                                EleUploadimage,
                                                                            },
            data() {
                return {
                                        table: {
                        url: '/member/MemberCard/index',
                        where: {"img":[]}                    },  // 表格配置
                    choose: [],  // 表格选中数据
                    showEdit: false,  // 是否显示表单弹窗
                    editForm: {"img":[]},  // 表单数据
                    editFormTemp:{"img":[]},
                    admin_list:[],
                    user_list:[],
                    search_show:false,
                                    editRules: {  // 表单验证规则
                                                            
                    create_time: [
                        {required: true, message: '请选择创建时间', trigger: 'blur'}
                    ],
                    
                                        
                    name: [
                        {required: true, message: '请输入会员卡名称', trigger: 'blur'}],
                    
                                        
                    img: [
                        {required: true, message: '请上传图片标识', trigger: 'blur'}
                    ],
                    
                                        
                    price: [
                        {required: true, message: '请输入会员价格', trigger: 'blur'}],
                    
                                        
                    day: [
                        {required: true, message: '请输入会员天数', trigger: 'blur'}],
                    
                                        
                    status: [
                        {required: true, message: '请输入卡状态，2显示，3隐藏', trigger: 'blur'}],
                    
                                        
                },
            }
            },
            computed: {
                ...mapGetters(["permission"]),
                            },
            mounted() {

                                                            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog(){
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/member/MemberCard/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({lock: true});
                            this.$http.post('/member/MemberCard/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({type: 'success', message: res.data.msg});
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) {  // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的会员卡信息吗?', '提示', {type: 'warning'}).then(() => {
                            const loading = this.$loading({lock: true});
                            this.$http.post('/member/MemberCard/delete', {id: ids}).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({type: 'success', message: res.data.msg});
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else {  // 单个删除
                        const loading = this.$loading({lock: true});
                        this.$http.post('/member/MemberCard/delete', {id:row.id}).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({type: 'success', message: res.data.msg});
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                                                /* 导出数据Excel */
                exportExcel() {
                    let ids  = this.choose.map(d => d.id)
                    if(ids.length == 0){
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/member/MemberCard/exportExcel", {id:ids})
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },
                
            
                }
        }
    </script>

    <style scoped>
        .ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
            width: 100%;
        }
    </style>
